import { Injectable } from '@angular/core';
import { UserService } from './user.service';

const maskList = ['ROLE_FORWARDER/mask1',
  'ROLE_FORWARDER/mask3',
  'ROLE_CHA/mask2',
  'ROLE_CHA/mask3',
  'ROLE_GHA/mask4'
];

const maskMap = new Set<string>(maskList);

@Injectable({
  providedIn: 'root'
})
export class AuthorizationService {

  constructor(private userService: UserService) { }

  maskAvailable(maskPath: string): boolean {
    const res = this.userService.currentUser()?.roles.find(role => maskMap.has(`${role}${maskPath}`));
    return res ? true : false;

  }

  noOfMasks(): number {
    const roles = this.userService.currentUser()?.roles || [];
    let res = 0;
    roles.forEach(role => {
      res += maskList.map(m => (m.startsWith(role) ? 1 : 0) as number).reduce((a, b) => a + b, 0);
    });
    return res;
  }

  firstMaskAvailable(): string | undefined {
    let maskPath = '';
    const roles = this.userService.currentUser()?.roles || [];
    let res;
    roles.forEach(role => {
      let elem = maskList.find(m => m.startsWith(role));
      if (elem) {
        res = elem.split('/')[1];
        return; // from forEach
      }
    });

    return res;
  }
}
